import {Checkbox, Stack} from '@mantine/core';
import type {FC} from 'react';
import type {ISelectOption} from 'src/types/Form';

/**
 * Labeled multi-choice checkbox group.
 * @registry Labeled multi-choice checkbox group.
 *
 * Ported from `library/elements/CheckboxGroup`, rebuilt on Mantine
 * `Checkbox.Group` (design/ is Mantine-only) instead of the original MUI
 * `Checkbox`/`FormGroup`. `onChangeCallback` is simplified from MUI's
 * per-checkbox `(event: ChangeEvent<HTMLInputElement>, checked: boolean) =>
 * void` to `(values: string[]) => void` — Mantine's `Checkbox.Group` hands
 * back the full selected list directly, which is a strictly more useful
 * shape than the previous per-item event (see
 * `SessionAnswerMultiChoice`, which previously reverse-engineered the
 * changed item from `event.target.name`). The unused `fullWidth` prop was
 * dropped (no consumer passed it).
 */
export interface CheckboxGroupProps {
  label: string;
  helperText?: string;
  disabled?: boolean;
  error?: boolean;
  options: ISelectOption[];
  values: string[];

  onChangeCallback: (values: string[]) => void;
}
export const CheckboxGroup: FC<CheckboxGroupProps> = ({
  label,
  helperText,
  disabled,
  error,
  options,
  values,
  onChangeCallback,
}) => {
  return (
    <Checkbox.Group
      label={label}
      description={helperText}
      error={error}
      value={values}
      onChange={onChangeCallback}>
      <Stack mt="xs" gap="xs">
        {options.map(option => (
          <Checkbox
            key={option.id}
            value={String(option.id)}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </Stack>
    </Checkbox.Group>
  );
};
